import { render } from "./pos-sidebar.vue?vue&type=template&id=1620c4bc"
import script from "./pos-sidebar.vue?vue&type=script&lang=js"
export * from "./pos-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__